import { render, staticRenderFns } from "./Bigevent.vue?vue&type=template&id=df9cf10a&"
import script from "./Bigevent.vue?vue&type=script&lang=js&"
export * from "./Bigevent.vue?vue&type=script&lang=js&"
import style0 from "./Bigevent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports